// The TSB Belt System — six stages of a bookkeeping firm.
//
// This is a display-only COPY of the ladder defined canonically in
// worker/src/belt.ts. The taker and worker are separate Vite/Workers apps
// (different bundlers, different tsconfigs) and cannot share source, so this
// file exists purely to turn a belt index (computed server-side and returned
// on the submission's scores.belt) into display strings.
//
// DO NOT add scoring logic here — scoreBelt() stays server-only, in
// worker/src/belt.ts. This file only ever reads an already-computed index.
//
// seeds/qa/qa-firm-runs-without-you.sql carries a case asserting these two
// ladders stay identical. If you change one, change both, in the same PR.
export interface Belt {
  key: 'white' | 'yellow' | 'green' | 'blue' | 'red' | 'black';
  name: string;
  stage: string;
}

export const BELTS: readonly Belt[] = [
  { key: 'white', name: 'White Belt', stage: 'Decision' },
  { key: 'yellow', name: 'Yellow Belt', stage: 'Value' },
  { key: 'green', name: 'Green Belt', stage: 'Activity' },
  { key: 'blue', name: 'Blue Belt', stage: 'Environment' },
  { key: 'red', name: 'Red Belt', stage: 'Leverage' },
  { key: 'black', name: 'Black Belt', stage: 'Exit' },
] as const;

export function beltAt(index: number): Belt {
  const i = Math.max(0, Math.min(BELTS.length - 1, Math.trunc(index)));
  return BELTS[i];
}
